$(document).ready(function() {
  var winW = $(window).width();

  lozad_function();

  $(window).load(function() {
    resizeHeader($('.barra').outerHeight(), $('header').outerHeight(), $('.infobar').outerHeight(), true);
  });

  $(window).resize(function() {
    resizeHeader($('.barra').outerHeight(), $('header').outerHeight(), $('.infobar').outerHeight(), false);
  });

  $('header .icons li .search').click(function() {
    $('header .big-search').toggleClass('show');
    $('header .black-search').toggleClass('show');
  });

  $('header .big-search .cerrar-big-search').click(function() {
    $('header .big-search').toggleClass('show');
    $('header .black-search').toggleClass('show');
  });

  $('header .icons li .cart').click(function() {
    $('#minicart').addClass('show');
  });

  $('#minicart .cerrar').click(function() {
    $('#minicart').removeClass('show');
  });

  // Pricecart
  $('header .icons li .price').click(function() {
    $('#pricecart').addClass('show');
  });

  $('#pricecart .cerrar').click(function() {
    $('#pricecart').removeClass('show');
  });

  $('header .show-menu').click(function() {
    $('nav').addClass('show');
  });

  $('header nav .cerrar').click(function() {
    $('nav').removeClass('show');
  });

  // Product
  $('#main-photo ul').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    asNavFor: '#mini-photos ul'
  });

  $('#mini-photos ul').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    vertical: false,
    asNavFor: '#main-photo ul',
    dots: false,
    arrows: false,
    centerMode: false,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 830,
        settings: {
          vertical: false,
        }
      }
    ]
  });

  $('.product .deon > h3').each(function() {
    $(this).addClass('accor');
    $(this).nextUntil('h3').wrapAll('<div class="hide-info"></div>')
  });

  $('.product .deon h3').click(function() {
    $(this).toggleClass('active');
    $(this).next('.hide-info').toggleClass('show');
  });

  // Interioristas
  $('.pro-int .gallery ul').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true
  });

  $('.pro-int .ver').click(function() {
    $('.pro-int .gallery').addClass('show');
  });

  $('.pro-int .gallery .cerrar').click(function() {
    $('.pro-int .gallery').removeClass('show');
  });

  $('.product .des-int .inner > h3').each(function() {
    $(this).addClass('h3-int');
    $(this).nextUntil('h3').wrapAll('<div class="contacto"></div>')
  });

  $('.pro-int .contactar').click(function() {
    $('.pro-int .form').addClass('show');
  });

  $('.pro-int .form .cerrar').click(function() {
    $('.pro-int .form').removeClass('show');
  });

  // Shop The Look
  $('.pro-shop #gallery ul').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    centerMode: true
  });

  // Collection
  if (winW < 830) {
    $('.facets__heading').click(function() {
      $(this).toggleClass('clicked');
      $('.template-collection .facets__disclosure').slideToggle(200);
    });
  }

  // Pop Up
  $('#popup .cerrar').click(function() {
    $('#popup').removeClass('show');
  });

  if (winW < 830) {
    $('nav ul.menu > li.site-nav--has-dropdown').prepend('<span class="down"><i>+</i></span>');
    $('nav ul.menu > li.site-nav--has-dropdown span.down').click(function() {
      $(this).toggleClass('active');
      $(this).parent().siblings().children('.sub-menu').removeClass('show');
      $(this).parent().children('.sub-menu').toggleClass('show');
    });
    $('nav ul.menu > li > ul.sub-menu > li.site-nav--has-dropdown').prepend('<span class="down"><i>+</i></span>');
    $('nav ul.menu > li > ul.sub-menu > li.site-nav--has-dropdown span.down').click(function() {
      $(this).toggleClass('active');
      $(this).parent().siblings().children('.sub-sub-menu').removeClass('show');
      $(this).parent().children('.sub-sub-menu').toggleClass('show');
    });
  }

  /**
   * Escucha permanente para agregar productos, funciona para snippet
   * product-item.liquid
   *
   * @param object this  Contiene el objeto del elemento cliqueado.
   */
  $('body').on('click', '.item .addcart', function() {
    var proVar = $(this).data('product-id');
    jQuery.ajax({
      type: "POST",
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: proVar
      },
      success: function(data) {
      },
      error: function(data) {
        if (data.status == 422) {
          $('.item-' + proVar + ' .alertas').text('Sin stock disponible');
        }
      },
      async: false
    });
    update_mini_cart(true);
  });

  // * Escucha permanente para agregar productos a cotizar
  // * product-item.liquid
  // *
  // * @param object this  Contiene el objeto del elemento cliqueado.
  // */

  $('.option_se').change(function() {
    var  precio    = $(selected).data('price');
    $("#add-to-price").attr('data-product-price-price', $('.product .right .price p.pnormal').text().replace(".", ""));
 
  });

  $('body').on('click', '#add-to-price', function (e) {
    e.preventDefault();

    $("#add-to-price").attr('data-product-price-price', $('.product .right .price p.pnormal').text());
    $("#add-to-price").attr('data-product-price-quantity', $('#Quantity').val());
    var proId = $(this).attr('data-product-price-id');
    var proToken = uuidv4();
    var proTitle = $(this).attr('data-product-price-title');
    var proExtra = $(this).attr('data-product-price-extra');
    var proSku = $(this).attr('data-product-price-sku');
    var proQuantity = $(this).attr('data-product-price-quantity');
    var prePrice = $(this).attr('data-product-price-price');
    var proPrice = prePrice.toString().replaceAll("$", "").replaceAll(".", "");
    var proImage = $(this).attr('data-product-price-image');
    var var_cotizador, cotizadorJson
    cotizadorJson = JSON.parse(getCotizacion('lab51_cotizador'));
    var var_cotizador = JSON.parse('{"token": "' + proToken + '", "id": "' + proId + '", "title": "' + proTitle + '", "extra": "' + proExtra + '", "sku": "' + proSku + '", "quantity": "' + proQuantity + '", "price": "' + proPrice + '00", "image": "' + proImage + '"}');
    cotizadorJson.cotizador.push(var_cotizador);
    setCotizacion("lab51_cotizador", JSON.stringify(cotizadorJson));
    $('#pricecart .middle ul').slick('slickAdd',"<li><div class='left'><i class='delete-prod' data-token='" + proToken + "'></i><h4>" + proTitle + "</h4><h5>" + prePrice + "</h5><h6>Cantidad: <span>" + proQuantity + "</span></h6></div><div class='right'><img src='" + proImage + "' alt='' /></div></li>");
    $('#pricecart .middle ul').slick('refresh');
    update_price_cart(true, false);
  });

  $('body').on('click', '#popup-cotizar .cerrar', function() {
    $('#popup-cotizar').removeClass('show');
  });

  $('body').on('click', '.ver-price', function() {
    $('#pricecart').removeClass('show');
    load_cotizacion();
    $('#popup-cotizar').addClass('show');
    $("#ContactFormName").delay(500).focus();
    document.getElementById("ContactFormName").focus();
  });
});

/**
 * Escucha permanente para borrar producto del mini carro
 *
 * @param object this  Contiene el objeto del elemento cliqueado.
 */
$('body').on('click', '#minicart .middle .left i.delete-prod', function() {
  var var_this = this;
  Shopify.removeItem($(this).data('id'), function() {
    $(var_this).css("margin", "0").parent().parent().slideUp(200);
    update_mini_cart(false, true);
  });
});

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function lozad_function() {
  lozad('.lozad', {
    load: function(el) {
      el.src = el.dataset.src ? el.dataset.src : el.src;
      el.onload = function() {
        el.classList.add('fade')
      }
    }
  }).observe();
}


/**
 * Actualiza el mini carro
 *
 * @param boolean show  Muestra el menu
 * @param boolean all   Actualiza el sector medio del mini carro
 */
function update_mini_cart(show = false, all = true) {
  if (all) {
    $('#minicart .middle ul').empty();
  }
  $("#minicart .cifra").empty();
  jQuery.get("/cart.js", function(data) {
    for (var i = 0; i < data.items.length; i++) {
      var titulo     = data.items[i]["product_title"];
      var varianteID = data.items[i]["variant_id"];
      var precio     = data.items[i]["price"] ? parseFloat(data.items[i]["price"]).toString().substring(0, parseFloat(data.items[i]["price"]).toString().length - 2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.") : '0';
      var cantidad   = data.items[i]["quantity"];
      var imagen     = data.items[i]["image"];
      var alt        = data.items[i]["featured_image"]["alt"];
      var proMini    = "<li><div class='left'><i class='delete-prod' data-id='" + varianteID + "'></i><h4>" + titulo + "</h4><h5>$" + precio + "</h5><h6>Cantidad: <span>" + cantidad + "</span></h6></div><div class='right'><img class='lozad' src='" + imagen + "' alt='" + alt + "' loading='lazy' /></div></li>";
      if (all) {
        $("#minicart .middle ul").append(proMini);
      }
    }
    var total     = data.total_price ? data.total_price.toString().substring(0, data.total_price.toString().length - 2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.") : '0';
    var itemcount = data.item_count;
    $("#minicart .cifra").html('$' + total);
    $("header .icons li a.cart .count").html(itemcount);
    update_price_cart(false, true);
    if (show) {
      $('#minicart').addClass('show');
    }
  }, 'json');
}

/**
 * Devuelve el stock de la variante seleccionada
 *
 * @param object stock  Inventario de la ariante
 */

 function get_stock(stock = 0) {
   if (stock == 0) {
     $('.remain p').html('Producto agotado');
     $('#sobre-agregar').fadeIn(100);
   } else if (stock == undefined ) {
     $('#sobre-agregar').fadeIn(100);
   } else if (stock == 1) {
     $('.remain p').html('Queda sólo ' + stock + ' unidad');
     $('#sobre-agregar').fadeOut(100);
   } else if (stock > 1 && stock < 6) {
     $('.remain p').html('Quedan sólo ' + stock + ' unidades');
     $('#sobre-agregar').fadeOut(100);
   } else {
     $('.remain p').html('');
     $('#sobre-agregar').fadeOut(100);
   }
 }
  /**
  * Actualiza el cotizador
  *
  * @param boolean show  Muestra el menu
  * @param boolean all   Actualiza el sector medio del mini carro
  */
 function update_price_cart(show = false, all = true, slick = true) {
  var suma_total = 0, itemcount = 0;
   updateCotizacion('lab51_cotizador');
   cotizacionJson = JSON.parse(getCotizacion('lab51_cotizador'));

  if (all) {
    $('#pricecart .middle ul').empty();
    try {
      $('#pricecart .middle ul').slick('unslick');
    } catch(e) {}
  }
  $("#pricecart .cifra").empty();
  var proMini = "";
   for (var i = 0; i < cotizacionJson.cotizador.length; i++) {
    var varianteID = cotizacionJson.cotizador[i]["id"];
    var token      = cotizacionJson.cotizador[i]["token"];
    var titulo     = cotizacionJson.cotizador[i]["title"];
    var price      = cotizacionJson.cotizador[i]["price"] ? parseFloat(cotizacionJson.cotizador[i]["price"]).toString().substring(0, parseFloat(cotizacionJson.cotizador[i]["price"]).toString().length - 2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.") : '0';
    var quantity   = cotizacionJson.cotizador[i]["quantity"];
    itemcount     += parseInt(quantity);
    suma_total    += parseInt(cotizacionJson.cotizador[i]["price"]) * parseInt(quantity);
    var imagen     = cotizacionJson.cotizador[i]["image"];
    proMini       += "<li><div class='left'><i class='delete-prod' data-token='" + token + "'></i><h4>" + titulo + "</h4><h5>$" + price + "</h5><h6>Cantidad: <span>" + quantity + "</span></h6></div><div class='right'><img src='" + imagen + "' alt='' /></div></li>";
  }
  if (all) {
    $("#pricecart .middle ul").html(proMini);
  }
  var total  = suma_total ? suma_total.toString().substring(0, suma_total.toString().length - 2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.") : '0';
  $("#pricecart .cifra").html('$' + total);
  $("header .icons li a.price .count").html(itemcount);
  if (suma_total > 0) {
    $('.cotizador').addClass('show');
  } else {
    $('.cotizador').removeClass('show');
  }
  if (all) {
    slick_price();
  }
  if (show) {
    $('#pricecart').addClass('show');
  }
}

/**
 * Actualiza el cotizador
 *
 * @param boolean show  Muestra el menu
 * @param boolean all   Actualiza el sector medio del mini carro
 */
function load_cotizacion() {
  var var_cotizador, cotizadorJson;
  var suma_total = 0, itemcount = 0;
  updateCotizacion('lab51_cotizador');
  var dec_cotizador = getCotizacion('lab51_cotizador');
  cotizadorJson = JSON.parse(dec_cotizador);
  var proMini = "Cotización\n\n";
  for (var i = 0; i < cotizadorJson.cotizador.length; i++) {
    var varianteID = cotizadorJson.cotizador[i]["id"];
    var token      = cotizadorJson.cotizador[i]["token"];
    var titulo     = cotizadorJson.cotizador[i]["title"];
    var extra = typeof (cotizadorJson.cotizador[i]["extra"]) != "undefined" ? cotizadorJson.cotizador[i]["extra"] : "";
    var sku     = cotizadorJson.cotizador[i]["sku"];
    var quantity   = cotizadorJson.cotizador[i]["quantity"];
    itemcount     += parseInt(quantity);
    suma_total     = parseInt(cotizadorJson.cotizador[i]["price"]) * parseInt(quantity);
    var price      = parseFloat(suma_total).toString().substring(0, parseFloat(suma_total).toString().length - 2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.");
    var imagen     = cotizadorJson.cotizador[i]["image"];
    proMini       += "Producto: " + titulo + " " /* + extra  */+ "\nSKU: " + sku + "\nCantidad: " + quantity + "\nPrecio: $" + price + "\n\n";
  }

  /*Se comento el extra para evitar que se duplique la variante y/o aparezca default title cuando no existe variante*/
  $("#popup-cotizar #ContactFormMessage").html(proMini);
}

/**
 * Escucha permanente para borrar producto del minicotizador
 *
 * @param object this  Contiene el objeto del elemento cliqueado.
 */
$('body').on('click', '#pricecart .middle .left i.delete-prod', function() {
  var cotizacionJson, dataRemoved, var_this = this, index = -1, val = $(this).attr('data-token');
  updateCotizacion('lab51_cotizador');

  var dec_cotizador = getCotizacion('lab51_cotizador');
  cotizadorJson = JSON.parse(dec_cotizador)

  dataRemoved = cotizadorJson.cotizador.filter((el) => {
    if (typeof(el) != "undefined") {
      return el.token !== val;
    }
  });
  setCotizacion('lab51_cotizador', '{"cotizador": ' + JSON.stringify(dataRemoved) + '}');
  $('#pricecart .middle ul').slick('slickRemove', parseInt($(this).parent().closest("li").attr("data-slick-index")));
  $('#pricecart .middle ul').slick('refresh');
  update_price_cart(false, false);
});


/**
 * Si en algún momento hay errores de carga de jQuery.
 * Uso: defer(function () { //= acá va la funcion =// });
 *
 * @param object method  Funcion completa a ejecutar
 */
function defer(method) {
  if (window.jQuery) {
    method();
  } else {
    setTimeout(function() { defer(method) }, 50);
  }
}

/* // Crea cookie
function setCookie(cname, cvalue, exdays = 7) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires     = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + encodeURIComponent(cvalue) + ";" + expires + ";path=/";
}

// Borra cookie
function deleteCookie(cname) {
  setCookie(cname, '', -1); 
}

// Obtiene cookie
function getCookie(cname) {
  var name          = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for (var i = ca.length - 1; i >= 0; i--) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

// Verifica cookie
function checkCookie(cname) {
  var cookieValue = getCookie(cname);
  if (cookieValue != "") {
    return true;
  } else {
    setCookie('lab51_cotizador', '{"cotizador":[]}', 7);
    return false;
  }
} */

/*----------------------------Fin Cookies------------------------------------*/

/*----------------------------Inicio localStorage--------------------------------*/

//Crea
const setCotizacion = function (cname, cvalue) {
  localStorage.setItem(cname, encodeURIComponent(cvalue));
}

//Borra
const deleteCotizacion = function (cname) {
  localStorage.removeItem(cname);
}

//Obtiene
const getCotizacion = function (cname) {
  var data = localStorage.getItem(cname);
  if (data != '' && data != undefined && data != null ) {   
    var decodeData = decodeURIComponent(data);
    return String(decodeData)
  } else {
    return '';
  }

}

//Verifica
const updateCotizacion = function (cname) {
  var localStorageData = getCotizacion(cname);
  if (localStorageData != "" && localStorageData != null && localStorageData != undefined) {
    return true;
  } else {
    setCotizacion('lab51_cotizador', '{"cotizador":[]}');
    return false;
  }
}

/*----------------------------Fin localStorage--------------------------------*/

function uuidv4() {
  return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  );
}

function slick_price() {
  $('#pricecart .middle ul').slick({
    dots: false,
    arrows: true,
    adaptiveHeight: true,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 830,
        settings: {
          dots: false,
          arrows: true,
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ]
  });
}

function quantity_elements(ajax = false) {
  if (ajax) {
    $('<div class="quantity-nav"><div class="quantity-button quantity-up">+</div><div class="quantity-button quantity-down">-</div></div>').insertAfter('.product-recommendations .sec-cantidad input');
    $('.product-recommendations .sec-cantidad').each(function() {
      var spinner = $(this), input = spinner.find('input[type="number"]'), btnUp = spinner.find('.quantity-up'), btnDown = spinner.find('.quantity-down'), min = input.attr('min'), max = input.attr('max');
      btnUp.click(function() {
        var oldValue = parseFloat(input.val());
        if (oldValue >= max) {
          var newVal = oldValue;
        } else {
          var newVal = oldValue + 1;
        }
        spinner.find("input").val(newVal);
        spinner.find("input").trigger("change");
      });
      btnDown.click(function() {
        var oldValue = parseFloat(input.val());
        if (oldValue <= min) {
          var newVal = oldValue;
        } else {
          var newVal = oldValue - 1;
        }
        spinner.find("input").val(newVal);
        $(spinner).parent().find(".addcart").data("qt", newVal);
        spinner.find("input").trigger("change");
      });
    });
  } else {
    $('<div class="quantity-nav"><div class="quantity-button quantity-up">+</div><div class="quantity-button quantity-down">-</div></div>').insertAfter('.sec-cantidad input');
    $('.sec-cantidad').each(function() {
      var spinner = $(this), input = spinner.find('input[type="number"]'), btnUp = spinner.find('.quantity-up'), btnDown = spinner.find('.quantity-down'), min = input.attr('min'), max = input.attr('max');
      btnUp.click(function() {
        var oldValue = parseFloat(input.val());
        if (oldValue >= max) {
          var newVal = oldValue;
        } else {
          var newVal = oldValue + 1;
        }
        spinner.find("input").val(newVal);
        spinner.find("input").trigger("change");
      });
      btnDown.click(function() {
        var oldValue = parseFloat(input.val());
        if (oldValue <= min) {
          var newVal = oldValue;
        } else {
          var newVal = oldValue - 1;
        }
        spinner.find("input").val(newVal);
        $(spinner).parent().find(".addcart").data("qt", newVal);
        spinner.find("input").trigger("change");
      });
    });
  }
}

document.addEventListener("DOMContentLoaded", function() {
  var lazyloadImages;

  if ("IntersectionObserver" in window) {
    lazyloadImages = document.querySelectorAll(".lazy");
    var imageObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var image = entry.target;
          image.classList.remove("lazy");
          imageObserver.unobserve(image);
        }
      });
    });

    lazyloadImages.forEach(function(image) {
      imageObserver.observe(image);
    });
  } else {
    var lazyloadThrottleTimeout;
    lazyloadImages = document.querySelectorAll(".lazy");

    function lazyload () {
      if(lazyloadThrottleTimeout) {
        clearTimeout(lazyloadThrottleTimeout);
      }

      lazyloadThrottleTimeout = setTimeout(function() {
        var scrollTop = window.pageYOffset;
        lazyloadImages.forEach(function(img) {
          if(img.offsetTop < (window.innerHeight + scrollTop)) {
            img.src = img.dataset.src;
            img.classList.remove('lazy');
          }
        });
        if(lazyloadImages.length == 0) {
          document.removeEventListener("scroll", lazyload);
          window.removeEventListener("resize", lazyload);
          window.removeEventListener("orientationChange", lazyload);
        }
      }, 20);
    }

    document.addEventListener("scroll", lazyload);
    window.addEventListener("resize", lazyload);
    window.addEventListener("orientationChange", lazyload);
  }
});

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    const summaryElements = this.querySelectorAll('summary');
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach(element => {
      element.setAttribute('role', 'button');
      element.setAttribute('aria-expanded', false);
      element.setAttribute('aria-controls', element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add('overflow-hidden-mobile');
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      document.body.classList.remove('overflow-hidden-mobile');
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

function resizeHeader(barraH = 0, headerH = 0, infoH = 0, scroll = true) {
  if ( $(window).width() > 830 ) {
    $('body').css('padding-top', infoH + headerH);
    $('header').css('top', infoH);
    if (scroll === true) {
      $(window).scroll(function() {
        if ($(window).scrollTop() > infoH) {
          $('header').addClass('fix');
          $('header').css('top', 0);
        } else {
          $('header').removeClass('fix');
          $('header').css('top', infoH);
          resizeHeader($('.barra').outerHeight(), $('header').outerHeight(), $('.infobar').outerHeight(), false);
        }
      });
    }
  } else {
    $('body').css('padding-top', barraH + headerH);
    $('header').css('top', barraH);
    if (scroll === true) {
      $(window).scroll(function() {
        if ($(window).scrollTop() > barraH) {
          $('header').addClass('fix');
          $('header').css('top', 0);
        } else {
          $('header').removeClass('fix');
          $('header').css('top', barraH);
        }
      });
    }
  }
}

// Product
$('.product .minides > h3').each(function() {
  $(this).addClass('accor');
  $(this).nextUntil('h3').wrapAll('<div class="hide-info"></div>')
});

$('.product .descon .tabs > h3').each(function(i) {
  $(this).addClass('h3 tab' + i).attr('data-id', i);
  $(this).nextUntil('h3').remove();
});

$('.product .descon .tabs > h3:nth-of-type(1)').addClass('active');

$('.product .descon .content > h3').each(function(i) {
  $(this).addClass('h3');
  $(this).nextUntil('h3').wrapAll('<div class="h3-next" data-id="' + i +'"></div>')
});

$('.product .descon .content > .h3-next:eq(0)').fadeIn(200).each(function() {
  var thisH = $(this).height();
  //$('.product .descon .content').css({'min-height' : thisH});
});

$('.product .descon .tabs > h3').each(function() {
  $(this).click(function(){
    $(this).siblings().removeClass('active');
    $(this).addClass('active');
    var id = $(this).attr('data-id');
    $('.product .descon .content [data-id="' + id + '"]').fadeIn(300);
    $('.product .descon .content [data-id="' + id + '"]').siblings().fadeOut(0);
  });
});